import React from 'react';
interface FermataMarkProps {
  variant?: 'default' | 'breath';
  animated?: boolean;
  className?: string;
}
export function FermataMark({
  variant = 'default',
  animated = false,
  className = ''
}: FermataMarkProps) {
  const color = variant === 'breath' ? 'var(--tw-colors-breath)' : 'var(--tw-colors-teal-DEFAULT)';
  return <span className={`inline-flex leading-none ${className}`} data-id="element-20">
      <svg width={variant === 'breath' ? '48' : '44'} height={variant === 'breath' ? '26' : '24'} viewBox="0 0 72 40" aria-hidden="true" className="overflow-visible" data-id="element-21">
        <path className="fill-none stroke-[1.6] stroke-linecap-round" stroke={color} d="M6 34 C6 14, 26 4, 36 4 C46 4, 66 14, 66 34" data-id="element-22" />
        <circle className={`fill-current ${animated ? 'motion-safe:animate-dot-breath origin-center [transform-box:fill-box]' : ''}`} style={{
        color
      }} cx="36" cy="22" r="4.2" data-id="element-23" />
      </svg>
    </span>;
}